export const alertBannerStyles = {
  bannerRoot: "flex items-center gap-3 rounded-xl border-warning-border bg-warning-bg px-4 py-3",
  bannerIcon: "h-4 w-4 shrink-0 text-warning",
  bannerTitle: "text-sm font-semibold text-strong",
  bannerSubtitle: "ml-2 text-sm text-muted-foreground",
  bannerAction:
    "shrink-0 text-xs font-semibold text-warning-strong transition-colors hover:text-warning-stronger",
  bannerDismiss: "ml-1 shrink-0 text-subtle transition-colors hover:text-muted-foreground",
  cardRoot: "mx-4 w-auto gap-x-2.5 rounded-xl border-warning-border bg-warning-bg p-3",
  cardIcon: "mt-0.5 text-warning",
  cardTitle: "pr-6 text-xs font-semibold text-strong",
  cardDescription: "mt-0.5 text-xs leading-relaxed text-muted-foreground",
  cardDismiss:
    "absolute right-3 top-3 shrink-0 text-subtle transition-colors hover:text-muted-foreground",
  cardButton:
    "col-start-2 mt-2.5 h-auto w-full rounded-lg bg-warning py-1.5 text-xs font-semibold text-white hover:bg-warning-dark",
  dismissIcon: "h-3.5 w-3.5",
};
